import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from "react-redux"
import PropTypes from 'prop-types'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

// Custom Component
import useLoading from "../Loading/useLoading"
import FullScreenDialog from "../Dialog/FullScreenDialog"
import DocSubSearchForm from "./DocSubSearchForm"
import DocSubDetailForm from "./DocSubDetailForm"
import DocSubCreateForm from "./DocSubCreateForm"

// Custom Style
import documentSubmissionStyle from '../../styles/jss/components/documentSubmission/documentSubmissionStyle'

// Global Function
import {getAdministrableRight, getModifyRight} from '../../global/userRight'

// Fetch Data
import {getSubmissionType, getSubmissionStage, documentSubmissionSearch} from '../../dataSource/documentSubmission'


const useStyles = makeStyles(theme => documentSubmissionStyle(theme))

const TabPanel = props => {
	const {children, value, index, ...other} = props

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={1}>
					<div>{children}</div>
				</Box>
			)}
		</div>
	)
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
}

const a11yProps = index => {
	return {
		id: `submission-tab-${index}`,
		'aria-controls': `submission-tabpanel-${index}`,
	}
}


const DocumentSubmission = () => {
	const classes = useStyles()
	const dispatch = useDispatch()

	// Redux Data
	const docSubSearchPropertyRedux = useSelector(state => state.docSubSearchPropertyRedux)
	const userModulesRedux = useSelector(state => state.userModulesRedux)

	const [tabValue, setTabValue] = useState(0)
	const [submissionType, setSubmissionType] = useState([])
	const [submissionStage, setSubmissionStage] = useState([])
	const [searchResult, setSearchResult] = useState([])
	const [searchMsg, setSearchMsg] = useState(null)
	const [docSubDetailDialogOpen, setDocSubDetailDialogOpen] = useState(false)
	const [searchResultLoading, searchResultShowLoading, searchResultHideLoading] = useLoading()
	
	const [administrableRight, setAdministrableRight] = useState(false)
	const [modifyRight, setModifyRight] = useState(false)

	// const [refresh]
	

	const handleTabChange = (event, newValue) => {
		setTabValue(newValue)
	}


	const docSubSearchAction = () => {
		setSearchMsg("")
		setSearchResult(null)
		searchResultShowLoading()

		documentSubmissionSearch(docSubSearchPropertyRedux).then(res => {
			if (res.data.length > 0) {
				setSearchMsg("")
				setSearchResult(res.data)
			}
			else {
				setSearchMsg("No Match Result")
			}

			// setSearchResult(res.data)
			searchResultHideLoading()
		})
		.catch(error => {
			setSearchResult([])
			setSearchMsg(error)
		})
	}


	// Dialog Open and Close
	const docSubDetailDialogHandleOpen = submissionSeq => {
		setDocSubDetailDialogOpen(true)

		dispatch({
			type: "SELECTED_SUBMISSION_SEQ",
			data: submissionSeq
		})
	}

	const docSubDetailDialogHandleClose = () => {
		dispatch({
			type: "SELECTED_SUBMISSION_SEQ",
			data: null
		})

		dispatch({
			type: "ADD_SUBMISSION_VALUE",
			data: null
		})

		dispatch({
			type: "MODIFY_SUBMISSION_VALUE",
			data: null
		})

		setDocSubDetailDialogOpen(false)
	}


	// Dialog button setting
	const docSubDetailDialogBtn = [
		// {
		// 	buttonName: "Edit",
		// 	buttonFunction: createFolderAction,
		// 	chooseFile: false
		// }
	]


	useEffect(() => {
		getAdministrableRight(userModulesRedux, "/submission").then(res => {
			setAdministrableRight(res)
		})

		getModifyRight(userModulesRedux, "/submission").then(res => {
			setModifyRight(res)
		})
	})

	useEffect(() => {
		getSubmissionType().then(res => {
			setSubmissionType(res.data)
		})

		getSubmissionStage().then(res => {
			setSubmissionStage(res.data)
		})
	}, [])


	return (
		// console.log("Administrable Right | Variable: administrableRight (DocumentSubmission.js)"),
		// console.log(administrableRight),

		// console.log("User Modify Right | Variable: modifyRight (DocumentSubmission.js)"),
		// console.log(modifyRight),

		// onsole.log("Document Submission Type Result | Variable: submissionType (DocumentSubmission.js)"),
		// console.log(submissionType),

		// onsole.log("Document Submission Stage Result | Variable: submissionStage (DocumentSubmission.js)"),
		// console.log(submissionStage),

		// console.log("Search property (Redux) | Variable: docSubSearchPropertyRedux (DocumentSubmission.js)"),
		// console.log(docSubSearchPropertyRedux),

		// console.log("Search property (Redux) | Variable: searchResult (DocumentSubmission.js)"),
		// console.log(searchResult),

		// console.log("---------------------------------------------------------------------------------"),

		
		<Fragment>
			<FullScreenDialog
				open={docSubDetailDialogOpen}
				dialogTitle={"Document Submission Detail"}
				formContent={<DocSubDetailForm 
					submissionSearchAction={docSubSearchAction}
				/>}
				button={docSubDetailDialogBtn}
				handleClose={docSubDetailDialogHandleClose}
			/>

			<div className={classes.root}>
				<AppBar position="static" color="default" >
					<Tabs value={tabValue} onChange={handleTabChange} aria-label="document submission tabs " textColor="primary" indicatorColor="primary">
						<Tab label="Search" {...a11yProps(0)} />
						<Tab label="New Submission" {...a11yProps(1)} />
					</Tabs>
				</AppBar>

				<TabPanel value={tabValue} index={0}>
					{
						modifyRight ? 
							<DocSubSearchForm
								submissionType={submissionType}
								submissionStage={submissionStage}

								// For Search
								searchLoading={searchResultLoading}
								searchMsg={searchMsg}
								submissionSearchAction={docSubSearchAction}
								searchResult={searchResult}

								//For Open Detail Dialog
								docSubDetailDialogHandleOpen={docSubDetailDialogHandleOpen}
							/>
						: <Typography variant="h5" className={classes.userRightMsg}>No User Right to access Document Submission</Typography>
					}
				</TabPanel>

				<TabPanel value={tabValue} index={1}>
					{
						modifyRight ?
							!administrableRight ?
								<DocSubCreateForm 
									submissionSearchAction={docSubSearchAction}
								/>
							: <Typography variant="h5" className={classes.userRightMsg}>No user right to create new Document Submission</Typography>
						: <Typography variant="h5" className={classes.userRightMsg}>No user right to create new Document Submission</Typography>
					}
				</TabPanel>
			</div>
		</Fragment>
	)
}


export default DocumentSubmission